import styles from './styles.module.css';
import { ActionItem } from '..';
import { Icon } from 'common/icon';
import { formatCreatedAtDate } from 'utils/formatDays';
import { IReply } from 'constants/types';
import { BlurHashImage } from 'components/blurhash-image';
import Link from 'next/link';

interface ReplyProps {
  reply: IReply;
  username?: string;
}

function getReplyUsername(reply: IReply, fallback?: string) {
  return reply.user?.username ?? reply.user_id?.username ?? fallback ?? 'User';
}

export const ReplyTopic = ({ reply }: ReplyProps) => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.accentBar} />
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <div className={styles.header}>
              <span className={styles.username}>{getReplyUsername(reply)}</span>
            </div>
            <p className={styles.message}>{reply.message}</p>
            {reply.imageUrl && (
              <Link href={reply.imageUrl} className={styles.attachedImage}>
                <BlurHashImage
                  src={reply.imageUrl ?? ''}
                  alt="Attached image"
                  width={100}
                  height={100}
                  blurhash={reply.blurHash}
                />
              </Link>
            )}
          </div>
        </div>
      </div>
      {reply.reply && (
        <div className={styles.replyInReplyPublication}>
          <ReplyTopic reply={reply.reply} />
        </div>
      )}
    </>
  );
};

export const ReplyPublication = ({ reply }: ReplyProps) => {
  return (
    <>
      <div className={styles.replySection}>
        <div className={styles.replyContent}>
          <div className={styles.replyHeader}>
            <div className={styles.replyAuthor}>{reply.user_id.username}</div>
            <div className={styles.replyDate}>
              {formatCreatedAtDate(reply.createdAt)}
            </div>
          </div>
          <p className={styles.replyText}>{reply.message}</p>

          {reply.imageUrl && (
            <Link href={reply.imageUrl} className={styles.attachedImage}>
              <BlurHashImage
                src={reply.imageUrl ?? ''}
                alt="Attached image"
                width={100}
                height={100}
                blurhash={reply.blurHash}
              />
            </Link>
          )}

          <div className={styles.replyActionBar}>
            <ActionItem icon={<Icon.Reply />} text="Reply" />
          </div>
        </div>
      </div>
      {reply.reply && (
        <div className={styles.replyInReplyPublication}>
          <ReplyPublication reply={reply.reply} />
        </div>
      )}
    </>
  );
};

export const ReplyComplaint = ({ reply, username }: ReplyProps) => {
  return (
    <article className={styles.reviewContainer}>
      {reply.reply && (
        <div className={styles.replyInReply}>
          <ReplyComplaint
            reply={reply.reply}
            username={getReplyUsername(reply.reply)}
          />
        </div>
      )}
      <header className={styles.reviewHeader}>
        <h2 className={styles.reviewerName}>{username}</h2>
        <time className={styles.reviewDate}>
          {formatCreatedAtDate(reply.createdAt)}
        </time>
      </header>
      <p className={styles.reviewContent}>{reply.message}</p>

      {reply.imageUrl && (
        <Link href={reply.imageUrl} className={styles.attachedImage}>
          <BlurHashImage
            src={reply.imageUrl ?? ''}
            alt="Attached image"
            width={100}
            height={100}
            blurhash={reply.blurHash}
          />
        </Link>
      )}

      <div className={styles.reviewActions}>
        <button className={styles.replyAction}>
          {/* <ActionItem icon={<Icon.Reply />} text="Reply" /> */}
        </button>
      </div>
    </article>
  );
};
